<script>
import Card from "@/components/forms/Card.vue";
import {mapActions} from "vuex";
import { VueDraggableNext } from 'vue-draggable-next'
import {findSelectItem, makeCode, showSystemNoti} from "@/shared/helper";
import ImagePicker from "@/components/ImagePicker.vue";
import CustomInput from "@/components/CustomInput.vue";
import {AppApi} from "@/api/AppApi";
import LawModal from "@/views/setting/lawModal.vue";
import AjaxForm from "@/components/forms/AjaxForm.vue";


export default {
  name: "ExploreFirstPageConfig",
  components: {AjaxForm, LawModal, CustomInput, ImagePicker, Card, draggable: VueDraggableNext},
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    addBannerBlock(type='desktop')
    {
      if (type === 'desktop')
        this.items.push({id : 't'+makeCode(8),type : 'banner',title : 'بلوک بنر',banners : []});
      else
        this.mobile_items.push({id : 't'+makeCode(8),type : 'banner',title : 'بلوک بنر',banners : []});
    },
    addSliderBlock(type='desktop')
    {
      if (type === 'desktop')
        this.items.push({id : 't'+makeCode(8),type : 'slider',title : 'بلوک اسلایدر',banners : []});
      else
        this.mobile_items.push({id : 't'+makeCode(8),type : 'slider',title : 'بلوک اسلایدر',banners : []})
    },
    addBannerItem(index,type='desktop')
    {
      if (type === 'desktop')
        this.items[index].banners.push({});
      else
        this.mobile_items[index].banners.push({});
    },
    deleteBannerItem(index,index2,type = 'desktop')
    {
      if (type === 'desktop')
      {
        const item = this.items[index];
        item.banners.splice(index2, 1);
      }
      else
      {
        const item = this.mobile_items[index];
        item.banners.splice(index2, 1);
      }
    },
    deletePageItem(index,type = 'desktop')
    {
      if (type ==='desktop')
        this.items.splice(index,1);
      else
        this.mobile_items.splice(index,1);
    },
    async getCustomersForSelect(index,q,loading)
    {
      loading(true);
      if (q.length)
      {
        const result = await AppApi.getAllConfirmedUserForSelectAjax(q);
        if (result.ok)
        {
          this.items[index].user_options = result.users
        }
      }
      loading(false);
    },
    async getCustomersForSelect2(index,q,loading)
    {
      loading(true);
      if (q.length)
      {
        const result = await AppApi.getAllConfirmedUserForSelectAjax(q);
        if (result.ok)
        {
          this.mobile_items[index].user_options = result.users
        }
      }
      loading(false);
    },
    async submitDesktopInfo(e)
    {
      const items = JSON.parse(JSON.stringify(this.items));
      const check_items = this.checkItemsErrors(items)
      if (check_items && check_items.ok)
      {

        this.setPageLoading(true);
        const top_page_background = this.top_page_background;
        const final = {items : items,top_page_background}
        const result = await AppApi.submitDesktopExploreItems(final);
        if (result.ok)
        {
          showSystemNoti('success',result.message)
        }
        else
          showSystemNoti('danger',result.error);
        this.setPageLoading(false);
      }
    },
    async submitMobileInfo(e)
    {
      const items = JSON.parse(JSON.stringify(this.mobile_items));
      const check_items = this.checkItemsErrors(items)
      if (check_items && check_items.ok)
      {
        this.setPageLoading(true);
        const top_page_background = this.mobile_top_page_background;
        const final = {items : items,top_page_background}
        const result = await AppApi.submitMobileExploreItems(final);
        if (result.ok)
        {
          showSystemNoti('success',result.message)
        }
        else
          showSystemNoti('danger',result.error);
        this.setPageLoading(false);
      }
    },
    checkItemsErrors(items)
    {
      const banner_sizes = ['12','6','4','3'];
      for (let i = 0; i < items.length; i++)
      {
        const item = items[i];
        if (item.type === 'banner')
        {
          const title = item.title;
          if (!title)
            return showSystemNoti('danger','عنوان بنرها نباید خالی باشد.');
          const banners = item.banners;
          if (banners && banners.length)
          {
            for (let j =0;j<banners.length;j++)
            {
              const banner = banners[j];
              let size = banner.size;
              if (!size)
                return showSystemNoti('danger','سایز بنرها را مشخص کنید.');
              console.log('size is ',size)
              console.log(isNaN(size))
              if (isNaN(size))
                return showSystemNoti('danger','سایز بنرها به درستی وارد نشده است');
              size = parseInt(size);
              if (size < 1 || size > 12)
                return showSystemNoti('danger','سایز بنر باید عددی بین 1 و 12 باشد');
              banner.size = size;
              const pic = banner.pic;
              if (!pic)
                return showSystemNoti('danger','تصویر بنر نمی تواند خالی باشد.')
              items[i] = item;
            }
          }
          else
            return showSystemNoti('danger','بنرهای بلوک بنر نباید خالی باشد')

        }
        else if (item.type === 'slider')
        {
          const title = item.title;
          if (!title)
            return showSystemNoti('danger','عنوان اسلایدر نباید خالی باشد.');
          const slider_type = item.slider_type;
          if (!slider_type)
            return showSystemNoti('danger','نوع اسلایدر را انتخاب کنید');
          if (slider_type.value)
            item.slider_type = slider_type.value;
          if (!item.n_show)
            return showSystemNoti('danger','تعداد نمایش اسلایدر نباید خالی باشد');
          const color = item.color;
          if (!color)
            return showSystemNoti('danger','رنگ اسلایدر باید انتخاب شود');
          item.color = item.color.value;
          if (item.slider_type === 'selectable')
          {
            //باید اینجا کاربرهایی رو طرف انتخاب کرده باشد
            const users = item.users;
            item.user_options = undefined;
            const user_ids = []
            if (users && users.length)
            {
              for (let k = 0;k<users.length;k++)
              {
                user_ids.push(users[k]._id);
              }
            }
            else
              return showSystemNoti('danger','کاربران اسلایدر را انتخاب کنید');
            item.users = undefined;
            item.user_ids = user_ids;

          }
          else if (item.slider_type === 'newest')
          {
            //اینجا باید حداقل یک پلن رو انتخاب کنه
            if (item.plans)
            {
              const plan_ids = [];
              if (Array.isArray(item.plans))
              {
                for (let k = 0;k<item.plans.length;k++)
                {
                  plan_ids.push(item.plans[k]._id);
                }
              }
              else
              {
                plan_ids.push(item.plans._id)
              }
              item.plan_ids = plan_ids;
            }
            else
              return showSystemNoti('danger','برای اسلایدر جدیدترین باید حداقل یک اشتراک انتخاب شود.');
          }
          item.users = undefined;
          item.plans = undefined;
          item.user_options = undefined;

        }
        else
          return showSystemNoti('danger','اطلاعات به درستی وارد نشده است');
      }
      return {ok : true,items}
    },
    async getPageItems()
    {
      this.pageLoaded = false;
      this.setPageLoading(true);
      const result = await AppApi.getExplorePageItems();
      if (result.ok)
      {
        this.upload_url = result.upload_url;
        const mobile_items = result.mobile_items;
        if (mobile_items.top_back && mobile_items.top_back.name)
        {
          this.mobile_top_page_background = mobile_items.top_back._id;
          this.mobile_top_page_background_url = this.upload_url + mobile_items.top_back.name;
        }
        this.mobile_items = this.itemsMakeInfo(mobile_items.items);

        const desktop_items = result.desktop_items;
        if (desktop_items.top_back && desktop_items.top_back.name)
        {
          this.top_page_background = desktop_items.top_back._id;
          this.top_page_background_url = this.upload_url + desktop_items.top_back.name;
        }
        this.items = this.itemsMakeInfo(desktop_items.items);
        this.plan_options = result.plans;
        this.def_cover = result.cover_pic;
        this.def_profile = result.profile_pic;

      }
      this.setPageLoading(false);
      this.pageLoaded = true;
    },
    itemsMakeInfo(items)
    {
      for (let i = 0;i<items.length;i++)
      {
        const item = items[i];
        if (item.type === 'banner')
        {
          const banners = item.banners;
          for (let j = 0;j<banners.length;j++)
          {
            const banner = banners[j];
            const pic = banner.pic;
            if (pic.name)
            {
              banner.pic_url = this.upload_url + pic.name;
              banner.pic = banner.pic._id;
            }
          }
        }
        else if (item.type === 'slider')
        {
          const slider_type = item.slider_type;
          item.slider_type = findSelectItem(slider_type,this.slider_type_options,'value');
          item.color = findSelectItem(item.color,this.colors_options,'value');
        }
      }
      return items;
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('ویرایش صفحه نخست explore');
    this.setShowHead(true);
    this.getPageItems();
  },
  watch:{
    items :
        {
          handler()
          {

          },deep:true
        }
  },
  data()
  {
    return{
      items : [],
      mobile_items : [],
      banner_size_options : [
        {title : 'تمام صفحه',value : '12'},
        {title : 'نصف صفحه',value : '6'},
        {title : 'یک سوم صفحه',value : '4'},
        {title : 'یک چهارم صفحه ',value : '3'},
      ],
      slider_type_options : [
        {title : 'انتخابی',value : 'selectable'},
        {title : 'جدیدترین',value : 'newest'},
      ],
      colors_options : [
        {title : 'طلایی',value : 'gold'},
        {title : 'نقره ای',value : 'silver'},
        {title : 'برنزی',value : 'bronze'},
        {title : 'سفید',value : 'white'},
      ],
      top_page_background:null,
      top_page_background_url:null,
      mobile_top_page_background:null,
      mobile_top_page_background_url:null,
      upload_url : '',
      plan_options : [],
      pageLoaded : false,
      def_cover : null,
      def_profile : null,
    }
  }
}
</script>

<template>
  <Card v-if="pageLoaded">
    <h5 class="font-weight-bold">بخش دسکتاپ</h5>
    <div class="added-btns-div">
      <button @click="addBannerBlock()" class="btn btn-info">افزودن بلوک بنر</button>
      <button @click="addSliderBlock()" class="btn btn-info">افزودن اسلایدر</button>
    </div>

    <draggable v-if="items"  class="page-items " :list="items" @change="">
      <div class="drag-item card m-0" v-for="(item ,index) in items" :key="item">
        <template v-if="item.type === 'banner'">
          <div class="card-header" data-toggle="collapse" :data-target="'#'+item.id" aria-expanded="false" :aria-controls="item.id"  type="button">
            <div class="title">{{item.title}} </div>
            <div class="handel-btns">
              <button @click.prevent="deletePageItem(index)" type="button" class="handle btn btn-danger btn-sm"><i class="far fa-trash-can"></i></button>
            </div>
          </div>
          <div class="collapse" :id="item.id">
            <div class=" card-body">
              <div class="row">
                <div class="col-12 mb-2 col-md-6">
                  <input type="text" class="form-control" name="title" v-model="item.title" placeholder="عنوان بنر">
                </div>
                <div class="col-12 mb-2 col-md-6">
                  <button @click="addBannerItem(index)" class="btn btn-info btn-sm">افزودن بنر <i class="far fa-plus"></i></button>
                </div>
              </div>
              <div class="banners row">
                <div v-for="(banner,index2) in item.banners" :key="banner" class="col-12 col-md-4 mb-2 border p-2 position-relative">
                  <button @click="deleteBannerItem(index,index2)" class="btn btn-danger btn-sm delete-banner-btn"><i class="far fa-trash-can"></i></button>
                  <div class="mb-2"><ImagePicker :file_id="banner.pic" :file_url="banner.pic_url" v-model="banner.pic" class="d-block" name="pic"></ImagePicker></div>
                  <div>
                    <label>سایز در صفحه از 12</label>
                    <custom-input :without-label="true"  type="number" v-model="banner.size" placeholder="سایز بنر در صفحه"></custom-input>
                  </div>
                  <div class="mt-2"><CustomInput placeholder="لینک بنر"  v-model="banner.link" type="text" :without-label="true" ></CustomInput></div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="item.type === 'slider'">
          <div class="card-header" data-toggle="collapse" :data-target="'#'+item.id" aria-expanded="false" :aria-controls="item.id"  type="button">
            <div class="title">{{item.title}} </div>
            <div class="handel-btns">
              <button @click.prevent="deletePageItem(index)" type="button" class="handle btn btn-danger btn-sm"><i class="far fa-trash-can"></i></button>
            </div>
          </div>
          <div class="collapse" :id="item.id">
            <div class=" card-body">
              <div class="row">
                <div class="col-12 mb-2 col-md-3">
                  <label>عنوان</label>
                  <input type="text" class="form-control" name="title" v-model="item.title" placeholder="عنوان اسلایدر">
                </div>
                <div class="col-12 mb-2 col-md-3">
                  <label>نوع انتخاب :</label>
                  <custom-input  v-model="item.slider_type" name='slider_type' placeholder="نوع اسلایدر را انتخاب کنید" :select-options="slider_type_options" select-label="title" :without-label="true" type="select" ></custom-input>
                </div>
                <div class="col-12 mb-2 col-md-3">
                  <label>تعداد نمایش :</label>
                  <custom-input type="number" v-model="item.n_show" name="n_show" placeholder="تعداد نمایش را انتخاب کنید" without-label="true"></custom-input>
                </div>
                <div class="col-12 mb-2 col-md-3">
                  <label>رنگ اسلایدر :</label>
                  <custom-input v-model="item.color" name="color" placeholder="رنگ اسلایدر را انتخاب کنید" :select-options="colors_options" select-label="title" :without-label="true" type="select" ></custom-input>
                </div>
                <div v-if="item.slider_type && item.slider_type.value === 'newest'" class="col-12 mb-2 col-md-3">
                  <label>اشتراک ها</label>
                  <CustomInput :without-label="true" placeholder="اشتراک ها را انتخاب کنید" type="select" name="plans" v-model="item.plans" select-label="title" :select-options="plan_options" :select_multiple="true"></CustomInput>
                </div>
                <div class="col-12" v-if="item.slider_type && item.slider_type.value === 'selectable'">
                  <label>انتخاب کاربران</label>
                  <CustomInput type="select" :select_multiple="true" :select-options="item.user_options" select-label="title"  :without-label="true" v-model="item.users" :fetch-options="getCustomersForSelect" :loop-id="index"></CustomInput>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </draggable>
    <div class="top-background-img">
      <label class="font-weight-bold">تصویر پس زمینه بخش ابتدایی صفحه</label>
      <ImagePicker name="top" :file_id="top_page_background" :file_url="top_page_background_url" v-model="top_page_background" ></ImagePicker>
    </div>
    <div class="row">
      <div class="col-8 col-md-4 mx-auto">
        <button @click="submitDesktopInfo($event)" class="btn btn-primary btn-block btn-lg">ذخیره تنظیمات</button>
      </div>
    </div>
    <hr/>
    <h5 class="font-weight-bold">بخش موبایل</h5>
    <div class="added-btns-div">
      <button @click="addBannerBlock('mobile')" class="btn btn-info">افزودن بلوک بنر</button>
      <button @click="addSliderBlock('mobile')" class="btn btn-info">افزودن اسلایدر</button>
    </div>

    <draggable v-if="mobile_items"  class="page-items " :list="mobile_items" >
      <div class="drag-item card m-0" v-for="(item ,index) in mobile_items" :key="item">
        <template v-if="item.type === 'banner'">
          <div class="card-header" data-toggle="collapse" :data-target="'#'+item.id" aria-expanded="false" :aria-controls="item.id"  type="button">
            <div class="title">{{item.title}} </div>
            <div class="handel-btns">
              <button @click.prevent="deletePageItem(index,'mobile')" type="button" class="handle btn btn-danger btn-sm"><i class="far fa-trash-can"></i></button>
            </div>
          </div>
          <div class="collapse" :id="item.id">
            <div class=" card-body">
              <div class="row">
                <div class="col-12 mb-2 col-md-6">
                  <input type="text" class="form-control" name="title" v-model="item.title" placeholder="عنوان بنر">
                </div>
                <div class="col-12 mb-2 col-md-6">
                  <button @click="addBannerItem(index,'mobile')" class="btn btn-info btn-sm">افزودن بنر <i class="far fa-plus"></i></button>
                </div>
              </div>
              <div class="banners row">
                <div v-for="(banner,index2) in item.banners" :key="banner" class="col-12 col-md-4 mb-2 border p-2 position-relative">
                  <button @click="deleteBannerItem(index,index2,'mobile')" class="btn btn-danger btn-sm delete-banner-btn"><i class="far fa-trash-can"></i></button>
                  <div class="mb-2"><ImagePicker :file_id="banner.pic" :file_url="banner.pic_url" v-model="banner.pic" class="d-block" name="pic"></ImagePicker></div>
                  <div>
                    <label>سایز در صفحه از 12</label>
                    <custom-input :without-label="true" type="number" v-model="banner.size" placeholder="سایز بنر در صفحه"></custom-input>
                  </div>
                  <div class="mt-2" ><CustomInput :without-label="true" placeholder="لینک بنر" v-model="banner.link" type="text" ></CustomInput></div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="item.type === 'slider'">
          <div class="card-header" data-toggle="collapse" :data-target="'#'+item.id" aria-expanded="false" :aria-controls="item.id"  type="button">
            <div class="title">{{item.title}} </div>
            <div class="handel-btns">
              <button @click.prevent="deletePageItem(index,'mobile')" type="button" class="handle btn btn-danger btn-sm"><i class="far fa-trash-can"></i></button>
            </div>
          </div>
          <div class="collapse" :id="item.id">
            <div class=" card-body">
              <div class="row">
                <div class="col-12 mb-2 col-md-3">
                  <label>عنوان</label>
                  <input type="text" class="form-control" name="title" v-model="item.title" placeholder="عنوان اسلایدر">
                </div>
                <div class="col-12 mb-2 col-md-3">
                  <label>نوع انتخاب :</label>
                  <custom-input  v-model="item.slider_type" name='slider_type' placeholder="نوع اسلایدر را انتخاب کنید" :select-options="slider_type_options" select-label="title" :without-label="true" type="select" ></custom-input>
                </div>
                <div class="col-12 mb-2 col-md-3">
                  <label>تعداد نمایش :</label>
                  <custom-input type="number" v-model="item.n_show" name="n_show" placeholder="تعداد نمایش را انتخاب کنید" without-label="true"></custom-input>
                </div>
                <div class="col-12 mb-2 col-md-3">
                  <label>رنگ اسلایدر :</label>
                  <custom-input v-model="item.color" name="color" placeholder="رنگ اسلایدر را انتخاب کنید" :select-options="colors_options" select-label="title" :without-label="true" type="select" ></custom-input>
                </div>
                <div class="col-12 mb-2 col-md-3" v-if="item.slider_type && item.slider_type.value === 'newest'">
                  <label>اشتراک ها</label>
                  <CustomInput :without-label="true" placeholder="اشتراک ها را انتخاب کنید" type="select" name="plans" v-model="item.plans" select-label="title" :select-options="plan_options" :select_multiple="true"></CustomInput>
                </div>
                <div class="col-12" v-if="item.slider_type && item.slider_type.value === 'selectable'">
                  <label>انتخاب کاربران</label>
                  <CustomInput type="select" :select_multiple="true" :select-options="item.user_options" select-label="title"  :without-label="true" v-model="item.users" :fetch-options="getCustomersForSelect2" :loop-id="index"></CustomInput>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </draggable>
    <div class="top-background-img">
      <label class="font-weight-bold">تصویر پس زمینه بخش ابتدایی صفحه</label>
      <ImagePicker :file_url="mobile_top_page_background_url" :file_id="mobile_top_page_background" v-model="mobile_top_page_background" ></ImagePicker>
    </div>
    <div class="row">
      <div class="col-8 col-md-4 mx-auto">
        <button @click="submitMobileInfo($event)" class="btn btn-primary btn-block btn-lg">ذخیره تنظیمات</button>
      </div>
    </div>
  </Card>
  <Card header="تصاویر پیش فرض">
    <ajax-form route="admin/user/submitDefaultExploreImage">
    <div class="row">
      <div class="col-12 col-md-6 mb-3">
        <label>تصویر پروفایل عمومی</label>
        <image-picker v-if="def_profile" :file_url="upload_url+def_profile.name" :file_id="def_profile._id" name="profile_pic"></image-picker>
        <image-picker v-else name="profile_pic"></image-picker>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <label>تصویر کاور عمومی</label>
        <image-picker v-if="def_cover" :file_url="upload_url+def_cover.name" :file_id="def_cover._id" name="cover_pic"></image-picker>
        <image-picker v-else name="cover_pic"></image-picker>
      </div>
      <div class="col-6 mx-auto my-3">
        <button type="submit" class="btn btn-info btn-block">ثبت تغییرات</button>
      </div>
    </div>
    </ajax-form>
  </Card>
</template>

<style scoped>
.added-btns-div
{
  display: flex;
  grid-gap: 5px;
}
.page-items
{
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  margin-top: 10px;
}
.drag-item {
  display: block;
  border: 1px solid silver;
  border-radius: 5px;
  padding: 5px;
}
.drag-item .card-header
{
  padding: 5px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-weight: bold;
}
.delete-banner-btn {
  position: absolute;
  left: 5px;
  top: 5px;
  z-index: 1;
}
.handel-btns
{
  display: flex;
  grid-column-gap: 3px;
}
.top-background-img
{
  margin-top: 10px;
}
</style>